export default function About() {
  return (
    <section className="py-20 px-6 text-center bg-white dark:bg-slate-900 transition-colors">
      <h2 className="text-3xl font-bold mb-8 dark:text-white  decoration-4 underline-offset-8">About Our Gym</h2>
      <p className="text-gray-600 dark:text-gray-400 max-w-3xl mx-auto text-lg leading-relaxed">
        Our gym is equipped with modern equipment and expert trainers to help you reach your goals. 
        We focus on results and community.
      </p>
    </section>
  );
}